var t = /* @__PURE__ */ ((r) => (r.primaryColor = "--THEME-primary", r.secondaryColor = "--THEME-secondary", r.tertiaryColor = "--THEME-tertiary", r.textColorPrimary = "--THEME-text-primary", r.textColorSecondary = "--THEME-text-secondary", r.borderColorTertiary = "--THEME-border-tertiary", r))(t || {});
export {
  t as ThemeRootNamesEnum
};
